import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import LandingHeader from './LandingHeader';
import { CLOUDFLARE_STATIC_ASSETS } from '../config/cloudflareAssets';
import './Marketing.css';

interface MarketingLayoutProps {
  children: ReactNode;
  className?: string;
  mainClassName?: string;
  onSignInClick?: () => void;
  onSignUpClick?: () => void;
}

const solutionLinks = [
  ['Strategic planning software', '/strategic-planning-software'],
  ['Strategy execution software', '/strategy-execution-software'],
  ['Business strategy software', '/business-strategy-software'],
  ['Strategic alignment software', '/strategic-alignment-software'],
  ['OKR software', '/okr-software'],
  ['Strategy management software', '/strategy-management-software'],
  ['Strategic planning tools', '/strategic-planning-tools'],
  ['Business planning software', '/business-planning-software'],
  ['Strategic execution platform', '/strategic-execution-platform'],
  ['Corporate strategy software', '/corporate-strategy-software'],
];

export function MarketingFooter() {
  return (
    <footer className="public-footer public-container">
      <div className="public-footer-top">
        <Link to="/" aria-label="StratPlan homepage">
          <img src={CLOUDFLARE_STATIC_ASSETS.LOGO_LIGHT} alt="StratPlan" width="168" />
        </Link>
        <nav aria-label="Footer navigation">
          <Link to="/strategic-framework">Product</Link>
          <Link to="/#framework">How it works</Link>
          <Link to="/health-check">Free tools</Link>
          <Link to="/pricing">Pricing</Link>
          <Link to="/advisers">Advisers</Link>
          <Link to="/about">Company</Link>
          <Link to="/blog">Blog</Link>
        </nav>
        <p>A more connected tomorrow.</p>
      </div>
      <div className="public-footer-bottom">
        <p>© {new Date().getFullYear()} StratPlan. All rights reserved.</p>
        <div>
          <Link to="/privacy">Privacy</Link>
          <Link to="/contact">Contact</Link>
        </div>
      </div>
      <details className="public-solution-links">
        <summary>Explore strategic planning solutions</summary>
        <nav aria-label="Strategic planning solutions">
          {solutionLinks.map(([label, to]) => (
            <Link key={to} to={to}>
              {label}
            </Link>
          ))}
        </nav>
      </details>
    </footer>
  );
}

export default function MarketingLayout({
  children,
  className = '',
  mainClassName = '',
  onSignInClick,
  onSignUpClick,
}: MarketingLayoutProps) {
  return (
    <div className={`public-site ${className}`}>
      <a href="#public-main" className="public-skip-link">
        Skip to content
      </a>
      <LandingHeader
        className="public-header"
        showFrameworkLink
        onSignInClick={onSignInClick}
        onSignUpClick={onSignUpClick}
      />
      <main id="public-main" className={`public-main ${mainClassName}`}>
        {children}
      </main>
      <MarketingFooter />
    </div>
  );
}
